import React from 'react';
import { FormControlLabel } from '@material-ui/core';
import { TextField, PrimaryCheckbox } from '../../components/AtomComponents';
import type { DiagnosticData, MannapovIceData, PhoneCheckData } from './types';
import { StepCard, StepField, StepHeader, StepFormContainer } from './PxwStepComponents';

interface DiagnosticStepProps {
  data: DiagnosticData;
  onChange: (data: DiagnosticData) => void;
}

const DiagnosticStep = ({ data, onChange }: DiagnosticStepProps) => {
  const setMannapov = (field: keyof MannapovIceData) => (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange({ ...data, mannapovIce: { ...data.mannapovIce, [field]: e.target.value.trim() } });

  const setPhoneCheck = (field: keyof PhoneCheckData) => (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange({ ...data, phoneCheck: { ...data.phoneCheck, [field]: e.target.value.trim() } });

  return (
    <StepCard>
      <StepHeader
        title="Diagnostic Software"
        subtitle="Select the diagnostic tools this tenant uses, then enter their credentials"
      />
      <StepFormContainer>
        <div className="small-12 margin-bottom-3">
          <p className="pxw-field-label margin-bottom-1">Tools</p>
          <div className="pxw-tools-row">
            <FormControlLabel
              label="MANNAPOV ICE"
              control={
                <PrimaryCheckbox
                  checked={data.enableMannapovIce}
                  onChange={(_e, checked) => onChange({ ...data, enableMannapovIce: checked })}
                />
              }
            />
            <FormControlLabel
              label="PHONE CHECK"
              control={
                <PrimaryCheckbox
                  checked={data.enablePhoneCheck}
                  onChange={(_e, checked) => onChange({ ...data, enablePhoneCheck: checked })}
                />
              }
            />
          </div>
        </div>

        <div className="grid-x">
          {data.enableMannapovIce && (
            <div className={`small-12 ${data.enablePhoneCheck ? 'medium-6 pxw-col-left' : ''}`}>
              <p className="pxw-col-section-label pxw-col-section-label--warning">Mannapov ICE</p>
              <StepField label="Bearer">
                <TextField size="small" fullWidth required name="mannapov-bearer" placeholder="your-mannapov-bearer-token" value={data.mannapovIce.bearer} onChange={setMannapov('bearer')} />
              </StepField>
              <StepField label="Base URL">
                <TextField size="small" fullWidth required name="mannapov-baseUrl" placeholder="<HOST_ONLY: example.com or api.example.com>" value={data.mannapovIce.baseUrl} onChange={setMannapov('baseUrl')} />
              </StepField>
              <StepField label="License">
                <TextField size="small" fullWidth required name="mannapov-license" placeholder="your-license-key" value={data.mannapovIce.license} onChange={setMannapov('license')} />
              </StepField>
            </div>
          )}

          {data.enablePhoneCheck && (
            <div className={`small-12 ${data.enableMannapovIce ? 'medium-6 pxw-col-right' : ''}`}>
              <p className="pxw-col-section-label pxw-col-section-label--primary">Phone Check</p>
              <StepField label="API Key">
                <TextField size="small" fullWidth required name="phonecheck-apiKey" placeholder="pxw-phonecheck-api-key" value={data.phoneCheck.apiKey} onChange={setPhoneCheck('apiKey')} />
              </StepField>
              <StepField label="User Name">
                <TextField size="small" fullWidth required name="phonecheck-userName" placeholder="pxw-phonecheck-username" value={data.phoneCheck.userName} onChange={setPhoneCheck('userName')} />
              </StepField>
            </div>
          )}

          {!data.enableMannapovIce && !data.enablePhoneCheck && (
            <div className="small-12">
              <p className="faded_1">Default demo settings will apply if no tool is selected.</p>
            </div>
          )}
        </div>
      </StepFormContainer>
    </StepCard>
  );
};

export default DiagnosticStep;
